import src from "IMAGE";
export default { src, width: 186, height: 40, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AGxsbFh2dnZieXl5ZmRkZFNBQUE0TUhLPWoiU3CRM1iOAG1tbVl3d3djZmZmVWFhYU9UVFRCTExOPltAZHGETFGQGMMXormTp5EAAAAASUVORK5CYII="};
